module.exports = __webpack_public_path__ + "img/turkiye-logo-icon.07599e92.png";